// extracted by mini-css-extract-plugin
export default {"error":"ErrorPage_error__jdhPg","title":"ErrorPage_title__SEONk","subtitle":"ErrorPage_subtitle__ceq9f","homeButton":"ErrorPage_homeButton__gXM3q"};